<template>
  <div class="law-cases-filter filters-container">
    <select-filter
      type="lawCases"
      field="from_company"
      label="Тип"
      :values="values"
      :parse-value="({ name }) => name"
    />
    <select-filter
      type="lawCases"
      field="status"
      label="Статус"
      request="objectInfo/law_statuses"
      :parse-value="({ name }) => name"
    />
    <sorting-control
      style="margin-left: 32px;"
      type="lawCases"
      :values="sortingFields"
    />
  </div>
</template>

<script>
import SelectFilter from './helpers/select-filter'
import SortingControl from './helpers/sorting-control'

const values = [
  { id: 'all', name: 'Все' },
  { id: 'true', name: 'От компании' },
  { id: 'false', name: 'На компанию' }
]
const sortingFields = [
  { field: 'costs', name: 'Сумма' }
]

export default {
  components: {
    SelectFilter,
    SortingControl
  },
  data () {
    return {
      values,
      sortingFields
    }
  }
}
</script>

<style></style>
